import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    cancelInvoice: 'Mark as declined',
    delete: 'Delete',
    duplicate: 'Duplicate',
    edit: 'Edit',
    editInvoiceReminder: 'Edit reminder settings',
    markInvoiceAsPaid: 'Mark as paid',
    markInvoiceAsSent: 'Mark as sent',
    resend: 'Resend',
    reviseInvoice: 'Correct the invoice',
  },
  fr: {
    cancelInvoice: 'Marquer comme refusée',
    delete: 'Supprimer',
    duplicate: 'Dupliquer',
    edit: 'Modifier',
    editInvoiceReminder: 'Modifier les options de relance',
    markInvoiceAsPaid: 'Marquer comme payée',
    markInvoiceAsSent: 'Marquer comme envoyée',
    resend: 'Renvoyer',
    reviseInvoice: 'Corriger la facture',
  },
} as const);

export default locales;
